import { OpsSeverity, OpsSeverityLabels } from '@navio/nsdk';
import { constObjectToOptions } from './choiceOptions';

export const OPS_POLICY_SEVERITY_OPTIONS = [
  { value: 'AUTOMATIC', label: 'Automatic' },
  ...constObjectToOptions(OpsSeverity, OpsSeverityLabels)
];
